import { Link } from "react-router-dom";
import Icon from "./Icon";

export function Logo({ className = "", onClick, light = false }) {
  return (
    <Link
      to="/"
      onClick={onClick}
      data-testid="header-brand-logo"
      className={`inline-flex items-center gap-2 ${className}`}
    >
      <span className="grid place-items-center w-9 h-9 rounded-xl bg-brand-orange text-white shadow-sm">
        <Icon name="Wrench" className="w-5 h-5" />
      </span>
      <span className={`font-display text-xl font-extrabold tracking-tight ${light ? "text-white" : "text-navy"}`}>
        Apna<span className="text-brand-orange">Fix</span>
      </span>
    </Link>
  );
}
